export default "__VITE_ASSET__i$6P0ABb__"